"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TimeBar',
  computed: {
    ...(0, _vuex.mapGetters)(['expiryTime'])
  },
  methods: {
    getExpiryTime() {
      var timezone = _momentTimezone.default.tz.guess();
      return (0, _momentTimezone.default)(this.expiryTime).tz(timezone).format('YYYY-MM-DD  HH:mm:ssZZ').toString();
    }
  }
};